import { z } from 'zod';

export const effectiveDateFormSchema = z.object({
  option: z.enum(['TODAY', 'TOMORROW', 'NEXT_MONDAY', 'CUSTOM']),
  customDate: z.date(),
});

export type EffectiveDateFormValues = z.infer<typeof effectiveDateFormSchema>;
